import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface PreferencesState {
  keepLearning: boolean;
  toggleKeepLearning: (value: boolean) => void;

  sketchnoteRecommendations: boolean;
  toggleSketchnoteRecommendations: (value: boolean) => void;

  // blogWork: boolean;
  // toggleBlogWork: (value: boolean) => void;

  // blog: boolean;
  // toggleBlog: (value: boolean) => void;

  // proTips: boolean;
  // toggleProTips: (value: boolean) => void;

  // proTipsWork: boolean;
  // toggleProTipsWork: (value: boolean) => void;

  recentAssignedTasks: boolean;
  toggleRecentAssignedTasks: (value: boolean) => void;

  // continueFiles: boolean;
  // toggleContinueFiles: (value: boolean) => void;

  favoriteFiles: boolean;
  toggleFavoriteFiles: (value: boolean) => void;

  loFi: boolean;
  toggleLoFi: (value: boolean) => void;

  loFiWork: boolean;
  toggleLoFiWork: (value: boolean) => void;

  checkboxFileInvite: boolean;
  toggleCheckboxFileInvite: (value: boolean) => void;

  checkboxWorkspaceInvite: boolean;
  toggleCheckboxWorkspaceInvite: (value: boolean) => void;

  checkboxOrganisationInvite: boolean;
  toggleCheckboxOrganisationInvite: (value: boolean) => void;

  checkboxFileMention: boolean;
  toggleCheckboxFileMention: (value: boolean) => void;

  checkboxLessonMention: boolean;
  toggleCheckboxLessonMention: (value: boolean) => void;

  CheckboxActivityMention: boolean;
  toggleCheckboxActivityMention: (value: boolean) => void;

  CheckboxActivityShare: boolean;
  toggleCheckboxActivityShare: (value: boolean) => void;

  CheckboxActivityAssign: boolean;
  toggleCheckboxActivityAssign: (value: boolean) => void;

  CheckboxActivityInvite: boolean;
  toggleCheckboxActivityInvite: (value: boolean) => void;

  CheckboxActivityDeadline: boolean;
  toggleCheckboxActivityDeadline: (value: boolean) => void;

  CheckboxUpdateFeature: boolean;
  toggleCheckboxUpdateFeature: (value: boolean) => void;

  CheckboxUpdateTip: boolean;
  toggleCheckboxUpdateTip: (value: boolean) => void;

  CheckboxUpdateRecommended: boolean;
  toggleCheckboxUpdateRecommended: (value: boolean) => void;

  audioMode: string;
  setAudioMode: (value: string) => void;

  workLearnMode: string;
  setWorkLearnMode: (value: string) => void;

  askAlex: boolean;
  toggleAskAlex: (value: boolean) => void;

  learnAskAlex: boolean;
  toggleLearnAskAlex: (value: boolean) => void;

  calendar: boolean;
  toggleCalendar: (value: boolean) => void;

  yourWorkspaces: boolean;
  toggleYourWorkspaces: (value: boolean) => void;

  incompleteTasks: boolean;
  toggleIncompleteTasks: (value: boolean) => void;

  upcomingDeadlines: boolean;
  toggleUpcomingDeadlines: (value: boolean) => void;

  // quickNotepad: boolean;
  // toggleQuickNotepad: (value: boolean) => void;
  embedAnything: boolean;
  toggleEmbedAnything: (value: boolean) => void;

  // roadmapWork: boolean;
  // toggleRoadmapWork: (value: boolean) => void;
  changelogWork: boolean;
  toggleChangelogWork: (value: boolean) => void;
  helpcenterWork: boolean;
  toggleHelpcenterWork: (value: boolean) => void;

  setPreferenceValues: (
    args: Pick<
      PreferencesState,
      | 'checkboxWorkspaceInvite'
      | 'checkboxFileInvite'
      | 'checkboxOrganisationInvite'
      | 'checkboxFileMention'
      | 'checkboxLessonMention'
      | 'CheckboxActivityMention'
      | 'CheckboxActivityShare'
      | 'CheckboxActivityAssign'
      | 'CheckboxActivityInvite'
      | 'CheckboxActivityDeadline'
      | 'CheckboxUpdateFeature'
      | 'CheckboxUpdateTip'
      | 'CheckboxUpdateRecommended'
      | 'audioMode'
      | 'workLearnMode'
      | 'loFi'
      | 'loFiWork'
      | 'favoriteFiles'
      // | 'proTipsWork'
      // | 'proTips'
      // | 'blogWork'
      // | 'blog'
      | 'sketchnoteRecommendations'
      | 'recentAssignedTasks'
      | 'keepLearning'
      // | 'continueFiles'
      | 'askAlex'
      | 'learnAskAlex'
      | 'calendar'
      | 'yourWorkspaces'
      | 'incompleteTasks'
      | 'upcomingDeadlines'
      // | 'quickNotepad'
      | 'embedAnything'
      | 'changelogWork'
      | 'helpcenterWork'
      // | 'roadmapWork'
    >
  ) => void;
}

export const usePreferencesStore = create<
  PreferencesState,
  [['zustand/devtools', PreferencesState]]
>(
  devtools((set) => ({
    keepLearning: false,
    toggleKeepLearning: () => set((state) => ({ keepLearning: !state.keepLearning })),

    sketchnoteRecommendations: false,
    toggleSketchnoteRecommendations: () =>
      set((state) => ({ sketchnoteRecommendations: !state.sketchnoteRecommendations })),

    // proTips: false,
    // toggleProTips: () => set((state) => ({ proTips: !state.proTips })),

    // blogWork: false,
    // toggleBlogWork: () => set((state) => ({ blogWork: !state.blogWork })),

    // proTipsWork: false,
    // toggleProTipsWork: () => set((state) => ({ proTipsWork: !state.proTipsWork })),

    // blog: false,
    // toggleBlog: () => set((state) => ({ blog: !state.blog })),

    recentAssignedTasks: false,
    toggleRecentAssignedTasks: () =>
      set((state) => ({ recentAssignedTasks: !state.recentAssignedTasks })),

    // continueFiles: false,
    // toggleContinueFiles: () => set((state) => ({ continueFiles: !state.continueFiles })),

    favoriteFiles: false,
    toggleFavoriteFiles: () => set((state) => ({ favoriteFiles: !state.favoriteFiles })),

    loFi: false,
    toggleLoFi: () => set((state) => ({ loFi: !state.loFi })),

    loFiWork: false,
    toggleLoFiWork: () => set((state) => ({ loFiWork: !state.loFiWork })),

    checkboxFileInvite: false,
    toggleCheckboxFileInvite: (checkboxFileInvite) =>
      set(() => ({ checkboxFileInvite: checkboxFileInvite })),

    checkboxWorkspaceInvite: false,
    toggleCheckboxWorkspaceInvite: (checkboxWorkspaceInvite) =>
      set(() => ({ checkboxWorkspaceInvite: checkboxWorkspaceInvite })),

    checkboxOrganisationInvite: false,
    toggleCheckboxOrganisationInvite: (checkboxOrganisationInvite) =>
      set(() => ({ checkboxOrganisationInvite: checkboxOrganisationInvite })),

    checkboxFileMention: false,
    toggleCheckboxFileMention: (checkboxFileMention) =>
      set(() => ({ checkboxFileMention: checkboxFileMention })),

    checkboxLessonMention: false,
    toggleCheckboxLessonMention: (checkboxLessonMention) =>
      set(() => ({ checkboxLessonMention: checkboxLessonMention })),

    CheckboxActivityMention: false,
    toggleCheckboxActivityMention: (CheckboxActivityMention) =>
      set(() => ({ CheckboxActivityMention: CheckboxActivityMention })),

    CheckboxActivityShare: false,
    toggleCheckboxActivityShare: (CheckboxActivityShare) =>
      set(() => ({ CheckboxActivityShare: CheckboxActivityShare })),

    CheckboxActivityAssign: false,
    toggleCheckboxActivityAssign: (CheckboxActivityAssign) =>
      set(() => ({ CheckboxActivityAssign: CheckboxActivityAssign })),

    CheckboxActivityInvite: false,
    toggleCheckboxActivityInvite: (CheckboxActivityInvite) =>
      set(() => ({ CheckboxActivityInvite: CheckboxActivityInvite })),

    CheckboxActivityDeadline: false,
    toggleCheckboxActivityDeadline: (CheckboxActivityDeadline) =>
      set(() => ({ CheckboxActivityDeadline: CheckboxActivityDeadline })),

    CheckboxUpdateFeature: false,
    toggleCheckboxUpdateFeature: (CheckboxUpdateFeature) =>
      set(() => ({ CheckboxUpdateFeature: CheckboxUpdateFeature })),

    CheckboxUpdateTip: false,
    toggleCheckboxUpdateTip: (CheckboxUpdateTip) =>
      set(() => ({ CheckboxUpdateTip: CheckboxUpdateTip })),

    CheckboxUpdateRecommended: false,
    toggleCheckboxUpdateRecommended: (CheckboxUpdateRecommended) =>
      set(() => ({ CheckboxUpdateRecommended: CheckboxUpdateRecommended })),

    audioMode: '',
    setAudioMode: (audioMode) => set(() => ({ audioMode: audioMode })),

    workLearnMode: '',
    setWorkLearnMode: (workLearnMode) => set(() => ({ workLearnMode: workLearnMode })),

    askAlex: false,
    toggleAskAlex: () => set((state) => ({ askAlex: !state.askAlex })),

    learnAskAlex: false,
    toggleLearnAskAlex: () => set((state) => ({ learnAskAlex: !state.learnAskAlex })),

    calendar: false,
    toggleCalendar: () => set((state) => ({ calendar: !state.calendar })),

    yourWorkspaces: false,
    toggleYourWorkspaces: () => set((state) => ({ yourWorkspaces: !state.yourWorkspaces })),

    incompleteTasks: false,
    toggleIncompleteTasks: () => set((state) => ({ incompleteTasks: !state.incompleteTasks })),

    upcomingDeadlines: false,
    toggleUpcomingDeadlines: () =>
      set((state) => ({ upcomingDeadlines: !state.upcomingDeadlines })),

    // quickNotepad: false,
    // toggleQuickNotepad: () => set((state) => ({ quickNotepad: !state.quickNotepad })),

    embedAnything: false,
    toggleEmbedAnything: () => set((state) => ({ embedAnything: !state.embedAnything })),

    // roadmapWork: false,
    // toggleRoadmapWork: () => set((state) => ({ roadmapWork: !state.roadmapWork })),

    changelogWork: false,
    toggleChangelogWork: () => set((state) => ({ changelogWork: !state.changelogWork })),

    helpcenterWork: false,
    toggleHelpcenterWork: () => set((state) => ({ helpcenterWork: !state.helpcenterWork })),

    setPreferenceValues: (args) => set({ ...args }),
    setDashboardPreferenceValues: (args) => set({ ...args }),
  }))
);
